import { Box, Stack, Typography, useTheme } from '@mui/material';
import { FiPhone } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

import { CONTACT_INFO } from '../navbar/NavbarWithPopoverOnAccent/NavbarNavigateOptions';
import {
    NAVBAR_CTA_CALL_NOW,
    NAVBAR_CTA_WHATSAPP,
} from '../../locales/types';

/**
 * Fixed bottom-of-screen Call + WhatsApp bar. Mobile only.
 * Provides one-tap conversion on the most lead-heavy device.
 */
const StickyContactBar = () => {
    const theme = useTheme();
    const primary = theme.palette.primary.main;
    const { t } = useTranslation();

    return (
        <Box
            role="navigation"
            aria-label="Quick contact"
            sx={{
                display: { xs: 'flex', md: 'none' },
                position: 'fixed',
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: (th) => th.zIndex.appBar + 1,
                bgcolor: 'background.paper',
                borderTop: `1px solid ${theme.palette.divider}`,
                boxShadow: '0 -6px 18px rgba(0,0,0,0.08)',
                pb: 'env(safe-area-inset-bottom)',
            }}
        >
            <Stack direction="row" sx={{ width: '100%' }}>
                <Box
                    component="a"
                    href={CONTACT_INFO.phoneHref}
                    sx={{
                        flex: 1,
                        py: 1.5,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 1,
                        color: primary,
                        textDecoration: 'none',
                        fontWeight: 700,
                        fontSize: '0.95rem',
                        borderRight: `1px solid ${theme.palette.divider}`,
                        '&:active': { bgcolor: 'action.hover' },
                    }}
                >
                    <FiPhone size={18} />
                    <Typography component="span" sx={{ fontWeight: 700 }}>
                        {t(`component.navbar.${NAVBAR_CTA_CALL_NOW}`)}
                    </Typography>
                </Box>
                <Box
                    component="a"
                    href={CONTACT_INFO.whatsappHref}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                        flex: 1,
                        py: 1.5,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 1,
                        color: '#25D366',
                        textDecoration: 'none',
                        fontWeight: 700,
                        fontSize: '0.95rem',
                        '&:active': { bgcolor: 'action.hover' },
                    }}
                >
                    <FaWhatsapp size={20} />
                    <Typography component="span" sx={{ fontWeight: 700 }}>
                        {t(`component.navbar.${NAVBAR_CTA_WHATSAPP}`)}
                    </Typography>
                </Box>
            </Stack>
        </Box>
    );
};

export default StickyContactBar;
